export const getFirstVisibleSection = (ids: string[], setSelected: (selected: string) => void) => (): void => {
    for (let i = 0; i < ids.length; i += 1) {
        const { top } = window.document.getElementById(ids[i])?.getBoundingClientRect() ?? {}

        if (top && top > 0 && top < window.innerHeight) {
            setSelected(ids[i])
            break
        }
    }
}

export const buildUrl = (pathname: string, id: string, prefix: string | undefined): string =>
    `${pathname.replace(prefix || '', '').replace(/\/\//gi, '/')}#${id}`
